const topics = [
  { name: '97视频', count: '2.3k 讨论', hot: true },
  { name: '丝瓜视频', count: '1.8k 讨论', hot: true },
  { name: '蓝莓视频', count: '1.5k 讨论', hot: true },
  { name: '91在线视频', count: '1.2k 讨论', hot: false },
  { name: '糖心视频', count: '980 讨论', hot: true },
  { name: '黑桃视频', count: '760 讨论', hot: false },
  { name: '平台对比', count: '650 讨论', hot: false },
  { name: '会员评测', count: '520 讨论', hot: false },
  { name: '新平台探索', count: '430 讨论', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            热门话题标签
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            站内最受关注的在线视频平台相关话题
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-3 max-w-3xl mx-auto">
          {topics.map((topic, i) => (
            <div
              key={i}
              className="group inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 hover:bg-background-200 border border-background-200/60 hover:border-primary-200 rounded-full transition-all duration-200 cursor-pointer"
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-primary-500 flex-shrink-0"></span>
              )}
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-[11px] text-foreground-400 whitespace-nowrap">
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}